/**
 * O escopo do escritório, visível no cabeçalho de toda tela nova (spec 096).
 *
 * **POR QUE ISTO É COMPONENTE E NÃO ENFEITE.** O isolamento entre organizações é
 * verdadeiro no servidor e invisível na tela: quem olha um número de custo não
 * tem como saber de quem ele é. Numa conta com mais de um escritório, essa
 * dúvida transforma um dado certo em decisão errada. O chip diz de quem é o que
 * está na tela, sempre, sem o usuário precisar procurar.
 */
import { Building2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  nome?: string | null
  className?: string
}

export function EscopoDaOrganizacao({ nome, className }: Props) {
  if (!nome) return null
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-indigo-500/30',
        'bg-indigo-500/10 px-3 py-1 text-xs font-medium text-indigo-300',
        className
      )}
      title={`Todo dado desta tela é de ${nome}`}
    >
      <Building2 className="h-3.5 w-3.5" />
      só de {nome}
    </span>
  )
}
